export default {
  bind(el) {
    const iconDropDown = el.getElementsByClassName('icon--dropdown')[0];
    const input = el.getElementsByTagName('input')[0] || el.getElementsByTagName('select')[0];
    let open = false;
    input.addEventListener('blur', () => {
      open = false;
    });
    iconDropDown.addEventListener('click', () => {
      if (open) open = false;
      else {
        input.focus();
        open = true;
      }
    });
  },
}
